export const createAuthBtnSlice = (set) => ({
  authBtnList: [],
  setAuthBtnList: (authBtnList) => {
    set((state) => {
      state.authBtn.authBtnList = authBtnList;
    });
  },
});
